<template>
    <div>
        <div class="content-box first" style="padding-bottom: 0px">
            <TabsBar
                style="padding-top: 0px; position: relative; left: -25px"
                :active="1"
                :tabs="[
                    {name: '我发起的分账', url: '/manage/distribute/initiate'},
                    {name: '我收到的分账', url: '/manage/distribute/receive'},
                ]"
            ></TabsBar>
        </div>
        <div style="margin-top: 30px" v-loading="pageLoading" element-loading-text="加载分账列表中...">
            <div class="list">
                <IncomeDivisionRow v-for="item in listData" :key="item.id" :info="item" :type="1"></IncomeDivisionRow>
            </div>
            <NoData v-if="listData.length === 0" title="您还没有收到分账"></NoData>
            <div v-if="listData.length !== 0" class="page-pagination-box">
                <el-pagination
                    background
                    @size-change="resetQuery"
                    @current-change="fetch"
                    :current-page.sync="params.pageNo"
                    :page-sizes="$pageSizes"
                    :page-size.sync="params.pageSize"
                    layout="prev, pager, next"
                    :total="totalCount"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import IncomeDivisionRow from '../components/IncomeDivisionRow';
import {fetchReceiveList} from '@/api/distribute';
export default {
    components: {
        IncomeDivisionRow,
    },
    data() {
        return {
            totalCount: 0,
            listData: [],
            pageLoading: false,
            params: {
                pageNo: 1,
                pageSize: 20,
            },
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        resetQuery() {
            this.params.pageNo = 1;
            this.fetch();
        },
        async fetch() {
            this.pageLoading = true;
            const response = await fetchReceiveList(this.params.pageNo, this.params.pageSize);
            const {msg, state, result} = response.data;
            this.pageLoading = false;
            if (!state) return this.$message.error(msg || '');
            this.listData = result.result;
            this.totalCount = result.totalCount;
        },
    },
};
</script>
